import { AuxiliaryAccountsEquations } from '@components/model-data/auxiliary-accounts-equations/auxiliary-accounts-equations.component';
import { ExogenousLinesEquationsComponent } from '@components/model-data/exogenous-lines-equations/exogenous-lines-equations.component';
import { LiquiditySourceEquationsComponent } from '@components/model-data/liquidity-source-equations/liquidity-source-equations.component';
import { LookupDataComponent } from '@components/model-data/lookup-data/lookup-data.component';
import { BalanceSheetComponent } from '@components/model-structure/balance-sheet/balance-sheet.component';
import { ExogenousLinesComponent } from '@components/model-structure/exogenous-lines/exogenous-lines.component';
import { GlobalSettingsComponent } from '@components/model-structure/global-settings/global-settings.component';
import { LiquiditySourcesComponent } from '@components/model-structure/liquidity-sources/liquidity-sources.component';
import { LookupSetupComponent } from '@components/model-structure/lookup-setup/lookup-setup.component';
import { ScenarioTableComponent } from '@components/model-structure/scenarios/scenario-table/scenario-table.component';
import { ManageResultsComponent } from '@components/results/dialog/manage-results/manage-results.component';
import { ImportAlmDatasetComponent } from '@components/simulation/import-alm-dataset/import-alm-dataset.component';
import { SimulationSetComponent } from '@components/simulation/simulation-set/simulation-set.component';
import { RedirectSilentRenewComponent } from '@core/auth/redirect-silent-renew/redirect-silent-renew.component';
import { SigninOidcComponent } from '@core/auth/signin-oidc/signin-oidc.component';
import { Error401Component } from '@core/error-pages/error401/error401.component';
import { Error404Component } from '@core/error-pages/error404/error404.component';
import { NetworkErrorComponent } from '@core/error-pages/network-error/network-error.component';
import { TimeoutComponent } from '@core/error-pages/timeout/timeout.component';
import { HomeComponent } from '@core/home/home.component';
import { TemplateComponent } from '@core/template/template.component';
import { RequireAuthenticatedUserRouteGuardService } from '@guards/auth/require-authenticated-user-route-guard.service';
import { CanDeactivateGuard } from '@guards/can-deactivate/can-deactivate-guard.service';
import { Routes } from "@angular/router";

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'index', redirectTo: '/home' },
  { path: 'home', component: HomeComponent, canActivate: [RequireAuthenticatedUserRouteGuardService] },
  { path: 'signin-oidc', component: SigninOidcComponent },
  { path: 'redirect-silentrenew', component: RedirectSilentRenewComponent },

  // ================================
  // MODEL DATA - Routes
  // ================================
  {
    path: 'lookup-data',
    component: LookupDataComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    data: {
      section: 'ModelDataLookuptables',
    },
    outlet: 'data-outlet',
  },
  {
    path: 'exogenous-equations',
    component: ExogenousLinesEquationsComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    outlet: 'data-outlet',
    data: {
      section: 'ModelDataExogenousLinesEquations',
    },
  },
  {
    path: 'liquidity-equations',
    component: LiquiditySourceEquationsComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    outlet: 'data-outlet',
    data: {
      section: 'ModelDataLiquiditySourcesEquations',
    },
  },
  {
    path: 'auxiliary-equations',
    component: AuxiliaryAccountsEquations,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    outlet: 'data-outlet',
    data: {
      section: 'ModelDataAuxiliaryAccountsEquations',
    },
  },

  // ================================
  // MODEL SETTINGS - Routes
  // ================================
  {
    path: 'balance-sheet',
    component: BalanceSheetComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    canDeactivate: [CanDeactivateGuard],
    outlet: 'structure-outlet',
    data: {
      section: 'ModelStructureBalanceSheet',
    },
  },
  {
    path: 'scenarios',
    component: ScenarioTableComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    outlet: 'structure-outlet',
    data: {
      section: 'ModelStructureScenarios',
    },
  },
  {
    path: 'lookup-setup',
    component: LookupSetupComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    canDeactivate: [CanDeactivateGuard],
    outlet: 'structure-outlet',
    data: {
      section: 'ModelStructureLookupTables',
    },
  },
  {
    path: 'liquidity-sources',
    component: LiquiditySourcesComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    canDeactivate: [CanDeactivateGuard],
    outlet: 'structure-outlet',
    data: {
      section: 'ModelStructureLiquiditySources',
    },
  },
  {
    path: 'exogenous-lines',
    component: ExogenousLinesComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    canDeactivate: [CanDeactivateGuard],
    outlet: 'structure-outlet',
    data: {
      section: 'ModelStructureExogenousLines',
    },
  },
  {
    path: 'global-settings',
    component: GlobalSettingsComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    canDeactivate: [CanDeactivateGuard],
    outlet: 'structure-outlet',
    data: {
      section: 'GlobalSettings',
    },
  },
  {
    path: 'template',
    component: TemplateComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    outlet: 'structure-outlet',
  },

  // ================================
  // SIMULATION - Routes
  // ================================
  {
    path: 'simulation-set',
    component: SimulationSetComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    outlet: 'simulation-outlet',
    data: {
      section: 'Simulation',
    },
  },
  {
    path: 'simulation-assumptions',
    component: LookupDataComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    outlet: 'simulation-outlet',
    data: {
      section: 'ModelDataLookuptables',
    },
  },

  // ================================
  // MAIN ROUTES
  // ================================
  {
    path: 'results',
    component: ManageResultsComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    outlet: 'main-outlet',
  },
  {
    path: 'sim-importer',
    component: ImportAlmDatasetComponent,
    canActivate: [RequireAuthenticatedUserRouteGuardService],
    canDeactivate: [CanDeactivateGuard],
    outlet: 'importer-outlet',
    data: {
      section: 'Import',
    },
  },
  { path: 'error', component: NetworkErrorComponent },
  { path: 'timeout', component: TimeoutComponent },
  // { path: '401', component: Error401Component, outlet: 'administration-outlet' },
  // { path: '401', component: Error401Component, outlet: 'data-outlet' },
  // { path: '401', component: Error401Component, outlet: 'structure-outlet' },
  // { path: '401', component: Error401Component, outlet: 'main-outlet' },
  // { path: '401', component: Error401Component, outlet: 'simulation-outlet' },
  // { path: '401', component: Error401Component, outlet: 'importer-outlet' },
  { path: '404', component: Error404Component },
  { path: '401', component: Error401Component },
  { path: '**', component: Error404Component },
];
